/**
 * departmentDataService — departman verisi icin SQL-only adaptor.
 *
 * OKUMA: `GET /api/hr/departments` (companyId X-Company-Id header'inda otomatik).
 *        Cloud Functions / Firebase RTDB okumasi KULLANILMAZ.
 *
 * KIMLIK: SQL departmaninin int `id`'si kanonik anahtardir; ancak personel kayitlari
 *         eski Firebase push-key (`legacyFirebaseKey`) ile de referans verebildiginden
 *         `getDepartmentsMap` her iki anahtar uzerinden de erisim saglar.
 */

import { hrApi } from '../../config/apiClient';

export interface Department {
  /** SQL integer primary key (string'e cevrilmis). */
  id: string;
  name: string;
  description?: string | null;
  head?: string | null;
  branchesId?: string | null;
  /** Eski Firebase RTDB push-key (varsa). */
  legacyFirebaseKey?: string | null;
}

interface DepartmentRow {
  id: number;
  name: string;
  description?: string | null;
  head?: string | null;
  branchesId?: string | null;
  legacyFirebaseKey?: string | null;
}

function mapRow(row: DepartmentRow): Department {
  return {
    id: String(row.id),
    name: row.name || 'Bilinmeyen Departman',
    description: row.description ?? null,
    head: row.head ?? null,
    branchesId: row.branchesId ?? null,
    legacyFirebaseKey: row.legacyFirebaseKey ?? null,
  };
}

/** Sirketin departman listesini SQL'den okur. */
export async function getDepartments(_companyId?: string): Promise<Department[]> {
  const res = await hrApi.get('/api/hr/departments');
  const items: DepartmentRow[] = res.data?.items || [];
  return items.map(mapRow);
}

/**
 * Departmanlari hem SQL `id` hem de `legacyFirebaseKey` anahtarlari uzerinden
 * erisilebilir bir map olarak dondurur. Deger sekli RTDB ile uyumludur: `{ name, ... }`.
 */
export async function getDepartmentsMap(
  companyId?: string
): Promise<Record<string, Department>> {
  const list = await getDepartments(companyId);
  const map: Record<string, Department> = {};
  for (const dept of list) {
    map[dept.id] = dept;
    if (dept.legacyFirebaseKey) {
      map[dept.legacyFirebaseKey] = dept;
    }
  }
  return map;
}

const departmentDataService = { getDepartments, getDepartmentsMap };
export default departmentDataService;
